
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { GoogleOAuthProvider } from "@react-oauth/google";

// const domain = "https://dev-cs3xl1m2l3op5i58.us.auth0.com";
// const clientId = "2xCIjSFolaX4Jfpgl97Za3dOgIjYiSq3";
const react_app_google_client_id = '249567625524-iadn91g2j49od124jv5sjq83hbdi0ac8.apps.googleusercontent.com';

const root = createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={react_app_google_client_id}>
    <App />
  </GoogleOAuthProvider >
);
